module.exports = __webpack_public_path__ + "img/logo-vision-white.c4a58fb0.svg";